var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  fillRule: "evenodd",
  d: "m11.265 10.237-1.029 1.028L7.591 8.62l-2.644 2.645-1.029-1.028 2.645-2.645-2.645-2.645 1.029-1.029L7.59 6.563l2.645-2.645 1.029 1.029L8.62 7.592zM7.5 0C3.375 0 0 3.375 0 7.5S3.375 15 7.5 15 15 11.625 15 7.5 11.625 0 7.5 0",
  clipRule: "evenodd",
  opacity: 0.6
})));
export default SvgIconDelete;